import React from 'react';
import PropTypes from 'prop-types';
import { Panel } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight, faPlus } from '@fortawesome/pro-solid-svg-icons';

import LoadingSpinner from 'components/loading_spinner';
import ProjectCard from 'components/project/project_card';
import { LeadPropTypes } from 'components/project/prop_types';
import LeadsFunnel from 'components/project/leads_funnel';
import EmptyState from 'components/project/empty_state';

export class LeadsCard extends React.Component {
  static propTypes = {
    fetchingLeads: PropTypes.bool.isRequired,
    handleFilterChange: PropTypes.func,
    history: PropTypes.object.isRequired,
    leads: PropTypes.arrayOf(LeadPropTypes).isRequired,
    leadStatuses: PropTypes.array,
    metricsLayout: PropTypes.bool,
    showNewLeadModal: PropTypes.func
  };

  onNewLeadClicked = (e) => {
    e.preventDefault();
    if (this.props.showNewLeadModal) {
      this.props.showNewLeadModal();
    }
  }

  moveToLeadTab = (e) => {
    e.preventDefault();
    this.props.handleFilterChange({ leadStatus: null });
    this.props.history.push('project_leads');
  }

  isEmpty() {
    return this.props.leads.length === 0;
  }

  moveToTab = () => {
    this.props.history.push('project_leads');
  }

  renderEmptyState() {
    return (
      <EmptyState imageSrc="/images/project_empty_states/leads.svg" message="No Leads to display." />
    );
  }

  renderFunnel() {
    return (
      <LeadsFunnel
        handleFilterChange={this.props.handleFilterChange}
        leads={this.props.leads}
        leadStatuses={this.props.leadStatuses.filter(status => status.label !== 'Dead')}
        moveToTab={this.moveToTab}
        name="leads-funnel"
      />
    );
  }

  renderBody() {
    if (this.props.fetchingLeads) return <LoadingSpinner addBottomBuffer skipTopBuffer />;

    return this.isEmpty() ? this.renderEmptyState() : this.renderFunnel();
  }

  render() {
    const actions = [];

    if (!this.props.fetchingLeads) {
      actions.push(
        <a href="#" name="add-lead" onClick={this.onNewLeadClicked}>
          <FontAwesomeIcon icon={faPlus} size="sm"/> Lead
        </a>
      );
    }

    if (this.props.leads.length > 0 && this.props.history && this.props.handleFilterChange) {
      actions.push(
        <a href="#" name="lead-tab-link" onClick={this.moveToLeadTab}>
          <FontAwesomeIcon icon={faAngleDoubleRight}/> More
        </a>
      );
    }

    if (this.props.metricsLayout) {
      return (
        <Panel className="metrics-panel">
          <Panel.Body className="p-5">
            <div className="bottom-buffer-md">
              <span className="h2">
                Leads
              </span>
              {this.props.history && this.props.handleFilterChange &&
                <span className="pull-right">
                  <a href="#" name="lead-tab-link" onClick={this.moveToLeadTab}>
                    <FontAwesomeIcon icon={faAngleDoubleRight}/> More
                  </a>
                </span>
              }
            </div>
            {this.renderBody()}
          </Panel.Body>
        </Panel>
      );
    }
    return (
      <ProjectCard
        className="dynamic-height position-relative overview-panel"
        name="Leads"
        rightActions={actions}
        wrapBody={!this.isEmpty()}
      >
        {this.renderBody()}
      </ProjectCard>
    );
  }
}

export default withRouter(LeadsCard);
